<script setup>
  import tr_JMC from '@/assets/translations/Tr_Jmc.json';
  import { computed } from 'vue';
  import { getTranslation } from '@/assets/scripts/getTranslation';
  import { useRoute } from 'vue-router';

  const route = useRoute();
  const otpCode = route.query["otpcode"];
  const type = route.query["type"];

  var showOtpBox = computed(() => {
    return type != "activation-email" && !!otpCode
  });

  const appleUrl = 'https://apps.apple.com/us/app/jungle-math-challenge-7/id1641328045';
  const googleUrl = undefined;
  const amazonUrl = undefined;

</script>
<template>
  <main class="page-layout jungle-bg">

    <!-- Logo -->
    <div class="logo-jungle mb-4 text-center">
      <img :src="require(`@/assets/img/JMC/JungleLogo.svg`)" alt="logo Montessori">
    </div>

    <!-- White box (+ animated kids) -->
    <div class="whitebox whitebox--jungle gap-4 d-flex flex-column align-items-center" >

      <!-- OTP -->
      <div class="whitebox__otpcode"  v-if="showOtpBox">
        <div class="whitebox__title whitebox__title--jungle">
          {{ getTranslation('title-label', tr_JMC, $i18n.locale) }}
        </div>
        <div class="whitebox__subtitle">
          <div class="whitebox__otp">
            {{ otpCode }}
          </div>
          {{ getTranslation('subtitle-label', tr_JMC, $i18n.locale) }}
        </div>
      </div>

      <!-- Default box (no otp) -->
      <div class="whitebox__noapp" v-else>
        <div class="whitebox__title whitebox__title--jungle mb-3">
          {{ getTranslation('no-otp-title', tr_JMC, $i18n.locale) }}
        </div>
        <div class="whitebox__subtitle">
          {{ getTranslation('no-otp-subtitle', tr_JMC, $i18n.locale) }}
        </div>
      </div>

      <!-- Store Buttons -->
      <div class="whitebox__activation d-md-grid d-flex flex-column gap-lg-2 gap-1">
        <a v-if="appleUrl" :href="appleUrl" class="whitebox__activation-apple whitebox__activation-link" target="_blank">
          <img src="@/assets/img/AppStore-button.svg" alt="" class="whitebox__activation-img">
        </a>
        <a v-if="googleUrl" :href="googleUrl" target="_blank" class="whitebox__activation-google whitebox__activation-link">
          <img src="@/assets/img/GooglePlay-button.svg" alt="" class="whitebox__activation-img">
        </a>
        <a v-if="amazonUrl" :href="amazonUrl" target="_blank" class="whitebox__activation-amazon whitebox__activation-link">
          <img src="@/assets/img/Amazon-button.svg" alt="" class="whitebox__activation-img">
        </a>
      </div>

      <div class="whitebox__next" v-if="!otpCode">
        {{ getTranslation('next-label', tr_JMC, $i18n.locale) }}
      </div>

      <div class="whitebox__contact">
        <a :href="`https://edokiacademy.freshdesk.com/${$i18n.locale}/support/solutions/folders/44001232982`" target="_blank">
          {{ getTranslation('contact-label', tr_JMC, $i18n.locale) }}
        </a>
      </div>

      <div class="animations">
        <div class="animations__boy">
          <img src="@/assets/img/JMC/JMC_Character_750px.gif" alt="" class="animations__boy-img">
          <div class="animations__boy-shadow"></div>
        </div>
        <div class="animations__operations">
          <div class="animations__wrapper">
            <img src="@/assets/img/JMC/Addition.svg" alt="" class="animations__operation animations__operation--addition">
            <img src="@/assets/img/JMC/Subtraction.svg" alt="" class="animations__operation animations__operation--substraction">
            <img src="@/assets/img/JMC/Multiplication.svg" alt="" class="animations__operation animations__operation--multiplication">
            <img src="@/assets/img/JMC/Division.svg" alt="" class="animations__operation animations__operation--division">
          </div>
        </div>
      </div>

    </div>
    
  </main>
</template>

<style lang="scss" scoped>
  .jungle-bg {
    background-image: url(@/assets/img/JMC/BackgroundJungle.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #009248;
  }

  .logo-jungle {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .animations {
    &__boy {
      position: absolute;
      top: 0;
      left: -13rem;

      &-img {
        width: 15rem;
        position: absolute;
        z-index: 2;
      }

      &-shadow {
        width: 10rem;
        height: 2rem;
        border-radius: 50%;
        position: absolute;
        top: 28rem;
        right: -13rem;
        background: rgba(23, 111, 105, 0.2);
        z-index: 1;
      }
    }

    &__operations {
      position: absolute;
      top: 3rem;
      right: 5rem;
    }

    &__wrapper {
      position: relative;
    }

    &__operation {
      position: absolute;
      animation: operationsmove 2s infinite;

      &--substraction {
        top: 6rem;
        right: -14rem;
      }

      &--multiplication {
        top: 9rem;
        right: -8.5rem;
      }

      &--division {
        top: 15rem;
        right: -11.5rem;
      }
    }
  }

  .whitebox__title--jungle {
    color: #1a77e4
  }

  .whitebox {
    &__title {
      text-align: center;
    }

    &__subtitle {
      margin: 0 auto;
    }
  }

  @keyframes operationsmove {
    50% {transform: rotate(5deg);}
  }

  @media (max-width: 992px) {
    .animations {
      &__boy {
        top: 4rem;
        left: -10.5rem;

        &-img {
          width: 12rem;
        }

        &-shadow {
          width: 9rem;
          top: 22rem;
          right: -10.5rem;
        }
      }

      &__operations {
        top: 6rem;
        right: 4rem;
      }

      &__operation {
        &--addition {
          width: 6rem;
        }

        &--substraction {
          width: 6rem;
          top: 5rem;
          right: -11rem;
        }

        &--multiplication {
          width: 6rem;
          top: 8rem;
          right: -7.5rem;
        }

        &--division {
          width: 5rem;
          top: 13rem;
          right: -10rem;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .animations {
      &__boy {
        display: none;
      }

      &__operations {
        bottom: 2.5rem;
        top: auto;
        right: auto;
        left: 20%;
        /* position: static;
        width: 90vw; */

      }

      &__operation {
        width: initial;

        &--substraction {
          bottom: -3.5rem;
          top: auto;
          left: 11rem;
        }

        &--multiplication {
          bottom: -10rem;
          top: auto;
          left: 8rem;
        }

        &--division {
          bottom: -9.5rem;
          top: auto;
          left: 16rem;
        }
      }
    }

    .whitebox {
      &--jungle {
        padding: 1.5rem 0 3rem;
      }
    }
  }

  @media (max-width: 459px) {
    .logo-jungle {
      img {
        width: 70%;
      }
    }

    .animations {
      &__operations {
        left: 0;
      }
    }
  }
</style>